import * as types from './mutation-types.js';

export const setMessage = ({commit}, newText) => {
    commit(types.SET_MESSAGE, newText);
}